import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    marginTop: '40px',
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red',
    },
  },
  dialogContent: {
    marginTop: '10px',
  },
  dialogInputField: {
    marginBottom: '30px',
    '& .MuiInputBase-input': {
      fontWeight: '700',
      fontSize: '0.875rem',
      color: '#152C73',
    },
  },
  programNameInputValidation: {
    marginTop: '-30px',
    fontFamily: 'inherit',
    fontSize: '12px',
    color: 'red',
  },
}));
